<template>
    <modal
        headline="Dokumente filtern"
        :value="true"
        @input="$emit('input', $event)"
    >
        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <label for="searchTerm">Stichwortsuche</label>
                <auto-complete
                    id="searchTerm"
                    v-model="form.searchTerm"
                    input-class="form-control"
                    :show-no-data="false"
                />
            </div>

            <div class="form-group row">
                <div class="col-12 col-md-6">
                    <label for="year">Monat</label>
                    <select
                        v-model="form.month"
                        class="form-control"
                        id="month"
                    >
                        <option value="">Egal</option>
                        <option value="1">Januar</option>
                        <option value="2">Februar</option>
                        <option value="3">März</option>
                        <option value="4">April</option>
                        <option value="5">Mai</option>
                        <option value="6">Juni</option>
                        <option value="7">Juli</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">Oktober</option>
                        <option value="11">November</option>
                        <option value="12">Dezember</option>
                    </select>
                </div>
                <div class="col-12 col-md-6">
                    <label for="year">Jahr</label>
                    <select
                        v-model="form.year"
                        class="form-control"
                        id="year"
                    >
                        <option value="">Egal</option>
                        <option>2023</option>
                        <option>2022</option>
                        <option>2021</option>
                        <option>2020</option>
                        <option>2019</option>
                        <option>2018</option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <label for="source">Quelle</label>
                <select
                    v-model="form.source"
                    class="form-control"
                    id="source"
                >
                    <option value="">Egal</option>
                    <option value="cloud">Cloud</option>
                    <option value="mail">E-Mail</option>
                </select>
            </div>

            <app-button type="submit" class="mr-12">Filtern</app-button>
            <app-button type="reset" theme="default" @click.native="onReset">Filter zurücksetzen</app-button>
        </form>
    </modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import AppButton from '@/components/ui/Button.vue'
import AutoComplete from '@/components/ui/AutoComplete.vue'


export default {
    name: 'DocumentFilterModal',

    components: { Modal, AppButton, AutoComplete },

    props: {
        filters: { type: Object, required: true },
    },

    data () {
        return {
            form: {
                searchTerm: this.filters?.searchTerm,
                month: this.filters?.month,
                year: this.filters?.year,
                source: this.filters?.source,
                // @TODO tags: [],
            },
        }
    },

    mounted () {
        document.querySelector('#searchTerm input')?.focus()
    },

    methods: {
        onSubmit () {
            this.$emit('submit', this.form)
        },

        onReset () {
            this.form.searchTerm = ''
            this.form.month = ''
            this.form.year = ''
            this.form.source = ''

            this.$emit('submit', this.form)
        },
    },
}
</script>
